// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.5
//   protoc               v4.23.4
// source: producer/producer_label.proto

/* eslint-disable */

export const protobufPackage = "producer";

export enum ProducerLabel {
  PRODUCER_LABEL_UNSPECIFIED = 0,
  PRODUCER_LABEL_CAMERA = 1,
  PRODUCER_LABEL_MICROPHONE = 2,
  PRODUCER_LABEL_SCREEN_VIDEO = 3,
  PRODUCER_LABEL_SCREEN_AUDIO = 4,
  PRODUCER_LABEL_CUSTOM_VIDEO = 5,
  PRODUCER_LABEL_CUSTOM_AUDIO = 6,
  PRODUCER_LABEL_UNKNOWN = 7,
  UNRECOGNIZED = -1,
}

export function producerLabelFromJSON(object: any): ProducerLabel {
  switch (object) {
    case 0:
    case "PRODUCER_LABEL_UNSPECIFIED":
      return ProducerLabel.PRODUCER_LABEL_UNSPECIFIED;
    case 1:
    case "PRODUCER_LABEL_CAMERA":
      return ProducerLabel.PRODUCER_LABEL_CAMERA;
    case 2:
    case "PRODUCER_LABEL_MICROPHONE":
      return ProducerLabel.PRODUCER_LABEL_MICROPHONE;
    case 3:
    case "PRODUCER_LABEL_SCREEN_VIDEO":
      return ProducerLabel.PRODUCER_LABEL_SCREEN_VIDEO;
    case 4:
    case "PRODUCER_LABEL_SCREEN_AUDIO":
      return ProducerLabel.PRODUCER_LABEL_SCREEN_AUDIO;
    case 5:
    case "PRODUCER_LABEL_CUSTOM_VIDEO":
      return ProducerLabel.PRODUCER_LABEL_CUSTOM_VIDEO;
    case 6:
    case "PRODUCER_LABEL_CUSTOM_AUDIO":
      return ProducerLabel.PRODUCER_LABEL_CUSTOM_AUDIO;
    case 7:
    case "PRODUCER_LABEL_UNKNOWN":
      return ProducerLabel.PRODUCER_LABEL_UNKNOWN;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ProducerLabel.UNRECOGNIZED;
  }
}

export function producerLabelToJSON(object: ProducerLabel): string {
  switch (object) {
    case ProducerLabel.PRODUCER_LABEL_UNSPECIFIED:
      return "PRODUCER_LABEL_UNSPECIFIED";
    case ProducerLabel.PRODUCER_LABEL_CAMERA:
      return "PRODUCER_LABEL_CAMERA";
    case ProducerLabel.PRODUCER_LABEL_MICROPHONE:
      return "PRODUCER_LABEL_MICROPHONE";
    case ProducerLabel.PRODUCER_LABEL_SCREEN_VIDEO:
      return "PRODUCER_LABEL_SCREEN_VIDEO";
    case ProducerLabel.PRODUCER_LABEL_SCREEN_AUDIO:
      return "PRODUCER_LABEL_SCREEN_AUDIO";
    case ProducerLabel.PRODUCER_LABEL_CUSTOM_VIDEO:
      return "PRODUCER_LABEL_CUSTOM_VIDEO";
    case ProducerLabel.PRODUCER_LABEL_CUSTOM_AUDIO:
      return "PRODUCER_LABEL_CUSTOM_AUDIO";
    case ProducerLabel.PRODUCER_LABEL_UNKNOWN:
      return "PRODUCER_LABEL_UNKNOWN";
    case ProducerLabel.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}
